module.exports = __webpack_public_path__ + "img/Afdt-logo.8b8fe653.png";